// type Methods = 'POST' | 'GET' | 'PUT' | 'DELETE';

export const SERVER_ROUTES = {
  ADMIN_AUTH: { method: 'GET', path: '/api/auth/admin' },
  ADMIN_LOGOUT: { method: 'DELETE', path: '/api/auth/admin' },
  RESELLER_AUTH: { method: 'GET', path: '/api/auth/admin' },
  RESELLER_LOGOUT: { method: 'DELETE', path: '/api/auth/reseller' },
  TENANT_AUTH: { method: 'GET', path: '/api/auth/tenant' },

  PUBLIC_AREA_AUTH: {
    method: 'GET',
    path: '/api/website/:websiteId/auth/public-area',
  },

  PUBLIC_AREA_LOGOUT: {
    method: 'DELETE',
    path: '/api/website/:websiteId/auth/public-area',
  },
  
  // TODO ver se eh assim mesmo que usa.
  CUSTOMER_AUTH: {
    method: 'GET',
    path: '/api/website/:websiteId/auth/customer',
  },
  CUSTOMER_LOGIN: {
    method: 'POST',
    path: '/api/website/:websiteId/auth/customer/login',
  },
  CUSTOMER_FIRST_ACCESS: {
    method: 'POST',
    path: '/api/website/:websiteId/auth/customer/first-access',
  },
  CUSTOMER_FORGOT_PASSWORD: {
    method: 'POST',
    path: '/api/website/:websiteId/auth/customer/forgot-password',
  },
  CUSTOMER_PASSWORD_RECOVERY: {
    method: 'POST',
    path: '/api/website/:websiteId/auth/customer/password-recovery',
  },
  CUSTOMER_PROFILE: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/profile',
  },

  DELETE_CUSTOMER: {
    method: 'DELETE',
    path: '/api/website/:websiteId/customer',
  },

  CUSTOMER_INVOICES: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/invoice',
  },
  CUSTOMER_INVOICES_PIX_BOLETO: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/invoice?include[]=pix&include[]=boleto',
  },
  CUSTOMER_INVOICE: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/invoice/:invoiceId/:dueDate',
  },
  CUSTOMER_INVOICE_PIX: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/invoice/:invoiceId/:dueDate/pix',
  },
  CUSTOMER_INVOICE_BOLETO: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/invoice/:invoiceId/:dueDate/boleto',
  },

  CUSTOMER_NF: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/nf/:contractId',
  },
  CUSTOMER_HIRED_PACKAGES: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/hired-package',
  },
  HIRED_PACKAGE_TRUST_UNLOCK: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/hired-package/:hiredPackageId/trust-unlock',
  },
  HIRED_PACKAGE_DOWNLOAD: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/hired-package/:hiredPackageId/download',
  },

  CUSTOMER_SUPPORTS: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/support',
  },
  CUSTOMER_OPEN_TICKET: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/support',
  },
  CUSTOMER_SUPPORT: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/support/:supportId',
  },

  CUSTOMER_FEEDBACK: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/feedback',
  },

  CUSTOMER_CHANGE_PASSWORD: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/change-password',
  },

  TENANT_BRAND: {
    method: 'GET',
    path: '/api/website/:id/brand',
  },

  RESELLER_PROFILE_CHANGE_PASSWORD: {
    method: 'PUT',
    path: '/api/reseller/change-password',
  },

  CUSTOMER_LOGOUT: {
    method: 'DELETE',
    path: '/api/website/:websiteId/auth/customer',
  },

  ADMIN_CREATE: { method: 'POST', path: '/api/admin' },
  ADMIN_LOGIN: { method: 'POST', path: '/api/auth/admin' },
  /**
   * @todo Mudar para o method PUT ou PATCH. (ver qual usar certinho.)
   */
  ADMIN_CHANGE_PASSWORD: {
    method: 'POST',
    path: '/api/auth/admin/change-password',
  },
  CHANGE_ADMIN_PASSWORD: {
    method: 'PUT',
    path: '/api/admin/change-password',
  },

  READ_ADMIN_PROFILE: { method: 'GET', path: '/api/admin/profile' },

  CREATE_TENANT: { method: 'POST', path: '/api/tenant' },
  READ_TENANTS: { method: 'GET', path: '/api/tenant' },
  READ_TENANT: { method: 'GET', path: '/api/tenant/:id' },
  EDIT_TENANT: { method: 'PUT', path: '/api/tenant/:id' },
  DELETE_TENANT: { method: 'DELETE', path: '/api/tenant/:id' },

  GENERATE_TENANT_ASSETS: { method: 'POST', path: '/api/tenant/:id/assets' },
  READ_RESELLER_PROFILE: { method: 'GET', path: '/api/reseller/profile' },

  CREATE_RESELLER: { method: 'POST', path: '/api/reseller' },
  READ_RESELLERS: { method: 'GET', path: '/api/reseller' },
  READ_RESELLER: { method: 'GET', path: '/api/reseller/:id' },
  EDIT_RESELLER: { method: 'PUT', path: '/api/reseller/:id' },
  DELETE_RESELLER: { method: 'DELETE', path: '/api/reseller/:id' },
  // TODO: Mudar talvez de PATCH para PUT.
  CHANGE_RESELLER_PASSWORD: {
    method: 'PATCH',
    path: '/api/reseller/:id/change-password',
  },
  UPDATE_RESELLER_API_TOKEN: {
    method: 'PUT',
    path: '/api/reseller/:id/api-token',
  },

  RESELLER_LOGIN: { method: 'POST', path: '/api/auth/reseller' },
  RESELLER_PROFILE: { method: 'GET', path: '/api/reseller/profile' },

  GET_TENANT_SUBJECTS: { method: 'GET', path: '/api/tenant/subjects' },
  GET_WEBSITE_SUBJECTS: {
    method: 'GET',
    path: '/api/website/:websiteId/ixc/subjects',
  },

  PUBLIC_AREA_TWO_FACTOR: {
    method: 'POST',
    path: '/api/website/:websiteId/auth/public-area/two-factor',
  },
  PUBLIC_AREA_LOGIN: {
    method: 'POST',
    path: '/api/website/:websiteId/auth/public-area/login',
  },

  PAY_DIRECTLY_WITH_CARD: {
    method: 'POST',
    path: '/api/website/:websiteId/payment/card/:invoiceId',
  },

  SVA_LIST: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/sva'
  },
  CAMPSOFT_ACTIVATE: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/sva/campsoft'
  },
  ATPBOX_VERIFY_AND_ACTIVATE: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/sva/atpbox',
  },
  ATPBOX_FIND_USERS: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/sva/atpbox/:contractId/user',
  },
  ATPBOX_CREATE_USER: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/sva/atpbox/:contractId/user',
  },
  ATPBOX_DELETE_USER: {
    method: 'DELETE',
    path: '/api/website/:websiteId/customer/sva/atpbox/:contractId/user/:userId',
  },

  OLETV_VERIFY_AND_ACTIVATE: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/sva/oletv',
  },
  OLETV_VERIFY: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/sva/oletv/verify',
  },
  OLETV_RECOVERY_PASSWORD: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/sva/oletv/recovery-password',
  },

  OLETV_IXC_VERIFY: {
    method: 'GET',
    path: '/api/website/:websiteId/customer/sva/oletv-ixc/:contractId',
  },
  OLETV_IXC_ACTIVATE: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/sva/oletv-ixc',
  },

  WATCHTV_VERIFY_AND_ACTIVATE: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/sva/watchtv',
  },
  PLAYHUB_VERIFY_AND_ACTIVATE: {
    method: 'POST',
    path: '/api/website/:websiteId/customer/sva/playhub',
  },
  CHANGE_CPASSWORD_TOKEN: {
    method: 'PUT',
    path: '/api/admin/customer-password-token',
  },
  GET_CPASSWORD_TOKEN: {
    method: 'GET',
    path: '/api/admin/customer-password-token',
  },
  CHANGE_CUSTOMER_PASSWORD: {
    method: 'PUT',
    path: '/api/website/:websiteId/customer/password',
  },
} as const;
